/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryModalCreateMutationVariables = {|
  name?: ?string
|};
export type CategoryModalCreateMutationResponse = {|
  +recipeCategoryCreate: ?{|
    +recipeCategory: ?{|
      +id: string,
      +name: string,
    |}
  |}
|};
export type CategoryModalCreateMutation = {|
  variables: CategoryModalCreateMutationVariables,
  response: CategoryModalCreateMutationResponse,
|};
*/


/*
mutation CategoryModalCreateMutation(
  $name: String
) {
  recipeCategoryCreate(input: {name: $name}) {
    recipeCategory {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeCategoryCreatePayload",
    "kind": "LinkedField",
    "name": "recipeCategoryCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNode",
        "kind": "LinkedField",
        "name": "recipeCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryModalCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryModalCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CategoryModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryModalCreateMutation(\n  $name: String\n) {\n  recipeCategoryCreate(input: {name: $name}) {\n    recipeCategory {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ff35cfdcba8990f0d5e2b13973b945e3';

module.exports = node;
